<template>
	<App title="Stacs Advance">
		<div class="row">
			<div class="col">
				<Block type="data">
					<template #header>
						<h1 class="block-title">Advance - #{{ advance.id }}</h1>
					</template>
					<div class="row">
						<div class="col-8">
							<TextBlock label="User">
								{{ advance.user?.fullname }}
							</TextBlock>
						</div>
						<div class="col">
							<TextBlock label="Partner">
								{{ advance.user?.partner?.name }}
							</TextBlock>
						</div>
					</div>

					<div class="row">
						<div class="col-4">
							<TextBlock label="Amount">
								{{ $render.money(advance.amount) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Penalty Charge">
								{{ $render.money(advance.penalty) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Premium">
								{{ $render.money(advance.premium) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Debt">
								{{ $render.money(advance.debt) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Created">
								{{ $render.date(advance.created_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Due Date">
								{{ $render.date(advance.due_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Completed">
								{{ $render.date(advance.completed_at) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Pay Date">
								{{ $render.date(advance.pay_at) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Default">
								{{ $render.bool(advance.is_default) }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Active">
								{{ $render.bool(advance.active) }}
							</TextBlock>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<TextBlock label="Account Bank">
								{{ advance.user.account?.bank }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock :copyable="true" label="Account Number">
								{{ advance.user.account?.number }}
							</TextBlock>
						</div>
						<div class="col-4">
							<TextBlock label="Account Name">
								{{ advance.user.account?.name }}
							</TextBlock>
						</div>
					</div>
					<template #footer>
						<div class="row">
							<div class="col">
								<button class="btn btn-outline-secondary btn-icon btn-lg me-2" @click="onOpenFinancial"><i class="fas fa-eye"></i> Financial Document</button>
								<button class="btn btn-outline-secondary btn-icon btn-lg" @click="onOpenEmployment"><i class="fas fa-eye"></i> Employment Document</button>
							</div>
						</div>
					</template>
				</Block>
			</div>
		</div>
		<TransactionTable :model="advance" />
	</App>
	<DocumentModal ref="financial-modal" :media="advance.financial" title="Financial Document" />
	<DocumentModal ref="employment-modal" :media="advance.employment" title="Employment Document" />
</template>
<script lang="ts">
import type Advance from '@/models/Advance'
import TransactionTable from '@/pages/snippets/TransactionTable.vue'
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import DocumentModal from '@/vue/components/DocumentModal.vue'
import TextBlock from '@/vue/components/TextBlock.vue'
import App from '@/vue/templates/App.vue'
import { Component, Prop, Ref, Vue, toNative } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		TextBlock,
		Datatable,
		TransactionTable,
		DocumentModal,
	},
})
class Single extends Vue {
	@Prop({ type: Object })
	readonly advance!: Advance

	@Ref('financial-modal')
	readonly financial_modal!: InstanceType<typeof DocumentModal>

	@Ref('employment-modal')
	readonly employment_modal!: InstanceType<typeof DocumentModal>

	onOpenFinancial() {
		this.financial_modal.onShow()
	}

	onOpenEmployment() {
		this.employment_modal.onShow()
	}
}

export default toNative(Single)
</script>
